module.exports = __webpack_public_path__ + "img/sm-logo.51402bb2.png";